/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Plan_WeekInputs */

const en_today_plan_week = /** @type {(inputs: Today_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan the week`)
};

const de_today_plan_week = /** @type {(inputs: Today_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche planen`)
};

/**
* | output |
* | --- |
* | "Plan the week" |
*
* @param {Today_Plan_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const today_plan_week = /** @type {((inputs?: Today_Plan_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Plan_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_today_plan_week(inputs)
	return en_today_plan_week(inputs)
});